import { Box, Button, Fab, Typography } from "@mui/material";
import { type CSSObject, styled } from "styled-components";

export const ButtonContainer = styled(Box)<{ $shareContainerStyles?: CSSObject }>(
  ({ $shareContainerStyles }) =>
    $shareContainerStyles ?? {
      alignItems: "center",
      display: "flex",
      flexDirection: "row-reverse",
      gap: "10px",
      zIndex: 999,
    },
);

export const ShareLabel = styled(Typography)({
  color: "#FFF",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  padding: "0 12px",
  textTransform: "none",
});

export const ShareButtonsContainer = styled(Box)<{ $shareButtonsContainerStyles?: CSSObject }>(
  ({ $shareButtonsContainerStyles }) =>
    $shareButtonsContainerStyles ?? {
      display: "flex",
      gap: "10px",
    },
);

export const ShareButton = styled(Button)({
  background: "#323232",
  border: "none",
  borderRadius: "24px",
  color: "#fff",
  height: "37px",
  padding: "7px 16px",
  width: "max-content",
  "&:hover": {
    backgroundColor: "#323232",
  },
});

export const ShareFab = styled(Fab)<{ $fabButtonStyles?: CSSObject }>(
  ({ $fabButtonStyles }) =>
    $fabButtonStyles ?? {
      backgroundColor: "#323232",
      color: "#FFF",
      "& svg": {
        width: 40,
        height: 40,
      },
    },
);
